import { useCurrentUserContext } from '@openclassrooms/data-connect-web/users';
export default function useCanDisplayMerchandising() {
  const {
    isPending,
    currentUser
  } = useCurrentUserContext();
  if (isPending) {
    return;
  }
  const canDisplay = !currentUser || currentUser.enrollment === "Free" && !currentUser.organization;
  return canDisplay;
}